"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALERT_DISPLAY_TYPE", {
  enumerable: true,
  get: function get() {
    return _Alert.ALERT_DISPLAY_TYPE;
  }
});
Object.defineProperty(exports, "ALERT_SIZE", {
  enumerable: true,
  get: function get() {
    return _Alert.ALERT_SIZE;
  }
});
Object.defineProperty(exports, "ALERT_STYLE_TYPE", {
  enumerable: true,
  get: function get() {
    return _Alert.ALERT_STYLE_TYPE;
  }
});
exports.Alert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Alert = require("./Alert.types");
require("./Alert.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Alert = function Alert(_ref) {
  var _classNames;
  var children = _ref.children,
    title = _ref.title,
    _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? _Alert.ALERT_DISPLAY_TYPE.box : _ref$displayType,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _Alert.ALERT_STYLE_TYPE.info : _ref$styleType,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Alert.ALERT_SIZE["default"] : _ref$size,
    _ref$isDismissible = _ref.isDismissible,
    isDismissible = _ref$isDismissible === void 0 ? false : _ref$isDismissible,
    onClose = _ref.onClose,
    className = _ref.className,
    iconClassName = _ref.iconClassName;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleClose = function handleClose() {
    onClose === null || onClose === void 0 ? void 0 : onClose();
    setIsVisible(false);
  };
  if (!isVisible) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-Alert', "cds-Alert--".concat((0, _upperCaseFirst.upperCaseFirst)(displayType)), "cds-Alert--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-Alert--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== _Alert.ALERT_SIZE["default"]), (0, _defineProperty2["default"])(_classNames, 'cds-Alert--Dismissable', isDismissible), _classNames), className);
  var iconName = "IconAlert".concat((0, _upperCaseFirst.upperCaseFirst)(styleType));
  var iconClassNames = (0, _classnames["default"])('cds-Alert-Icon', iconClassName);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, displayType === _Alert.ALERT_DISPLAY_TYPE.notification ? /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: iconClassNames,
    name: _Icon.ICON_NAME.alertNotification
  }) : /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: iconClassNames,
    name: iconName
  }), /*#__PURE__*/_react["default"].createElement("div", null, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Alert-Title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Alert-Content"
  }, children)), isDismissible && /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    className: "cds-Alert-ButtonClose cds-AlertClose",
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost,
    onClick: handleClose
  }));
};
exports.Alert = Alert;
Alert.config = {
  displayType: _Alert.ALERT_DISPLAY_TYPE,
  styleType: _Alert.ALERT_STYLE_TYPE,
  size: _Alert.ALERT_SIZE
};